
const SET_ADDRESS = 'SET_ADDRESS'
const SET_USERTYPE = 'SET_USERTYPE'
const SET_AIR_TRANSPORT = 'SET_AIR_TRANSPORT'
const SET_SHIP_TRANSPORT = 'SET_SHIP_TRANSPORT'
const SET_SHIP__DESTIN_PORT = 'SET_SHIP__DESTIN_PORT'
const SET_SHIP__ORGIN_PORTT = 'SET_SHIP__ORGIN_PORTT'
const SET_AIR__DESTIN_PORT = 'SET_AIR__DESTIN_PORT'
const SET_AIR__ORGIN_PORTT = 'SET_AIR__ORGIN_PORTT'
import { getAddressDropdown, transportDrapDown, harborDrapDown } from '@/api/basic'

import { getUserType } from '@/api/system'
const basiData = {
  state: {
    addressDropOption: [],
    userTypeOptions: null,
    sysParams: null,
    // airTransportOptions: [],
    shipTransportOptions: [],
    shipDestinPortOptions: [],
    shipOrginPortOptions: [],
    airDestinPortOptions: [],
    airOrginPortOptions: []
  },
  mutations: {
    [SET_ADDRESS](state, data) {
     state.addressDropOption = data
    },
    [SET_USERTYPE](state, data) {
        const arr = []
        data && data.map(item => {
            arr.push({
                value: item.value,
                label: item.label
            })
        })
     state.userTypeOptions = arr
    },
    [SET_AIR_TRANSPORT](state, data) {
      state.airTransportOptions = data
    },
    [SET_SHIP_TRANSPORT](state, data) {
      state.shipTransportOptions = data
    },
    [SET_SHIP__DESTIN_PORT](state, data) {
      state.shipDestinPortOptions = data
    },
    [SET_SHIP__ORGIN_PORTT](state, data) {
      state.shipOrginPortOptions = data
    },
    [SET_AIR__DESTIN_PORT](state, data) {
      state.airDestinPortOptions = data
    },
    [SET_AIR__ORGIN_PORTT](state, data) {
      state.airOrginPortOptions = data
    }
  },
  actions: {
    getAddress({ commit }) {
      return new Promise((resolve, reject) => {
        getAddressDropdown()
          .then((res) => {
            commit(SET_ADDRESS, res.data.country)
            resolve(res)
          })
          .catch((err) => {
            return reject(err)
          })
      })
    },
    getUserTypeOption({ commit }) {
        return new Promise((resolve, reject) => {
            getUserType()
            .then((res) => {
              commit(SET_USERTYPE, res.data)
              resolve(res.data)
            })
            .catch((err) => {
              return reject(err)
            })
        })
    },
    getShipTransportOptions({ commit }) {
      return new Promise((resolve, reject) => {
        transportDrapDown({
          type: 1
        })
          .then((res) => {
            if (res.success) {
              commit(SET_SHIP_TRANSPORT, res.data)
            }
            resolve(res)
          })
          .catch((err) => {
            return reject(err)
          })
      })
    },
    getAirTransportOptions({ commit }) {
      return new Promise((resolve, reject) => {
        transportDrapDown({
          type: 0
        })
          .then((res) => {
            if (res.success) {
              commit(SET_AIR_TRANSPORT, res.data)
            }
            resolve(res)
          })
          .catch((err) => {
            return reject(err)
          })
      })
    },
    getShipDestinPortOptions({ commit }) {
      return new Promise((resolve, reject) => {
        harborDrapDown({
          portType: 1,
          type: 1
        })
          .then((res) => {
            if (res.success) {
              commit(SET_SHIP__DESTIN_PORT, res.data)
            }
            resolve(res)
          })
          .catch((err) => {
            return reject(err)
          })
      })
    },
    getShipOrginPortOptions({ commit }) {
      return new Promise((resolve, reject) => {
        harborDrapDown({
          portType: 1,
          type: 0
        })
          .then((res) => {
            if (res.success) {
              commit(SET_SHIP__ORGIN_PORTT, res.data)
            }
            resolve(res)
          })
          .catch((err) => {
            return reject(err)
          })
      })
    },
    getAirDestinPortOptions({ commit }) {
      return new Promise((resolve, reject) => {
        harborDrapDown({
          portType: 0,
          type: 1
        })
          .then((res) => {
            if (res.success) {
              commit(SET_AIR__DESTIN_PORT, res.data)
            }
            resolve(res)
          })
          .catch((err) => {
            return reject(err)
          })
      })
    },
    getAirOrginPortOptions({ commit }) {
      return new Promise((resolve, reject) => {
        harborDrapDown({
          portType: 0,
          type: 0
        })
          .then((res) => {
            if (res.success) {
              commit(SET_AIR__ORGIN_PORTT, res.data)
            }
            resolve(res)
          })
          .catch((err) => {
            return reject(err)
          })
      })
    }
  },
  getters: {
    addressDropOption: state => state.addressDropOption,
    userTypeOptions: state => state.userTypeOptions,
    // airTransportOptions: (state) => state.airTransportOptions,
    shipTransportOptions: (state) => state.shipTransportOptions,
    shipDestinPortOptions: (state) => state.shipDestinPortOptions,
    shipOrginPortOptions: (state) => state.shipOrginPortOptions,
    airDestinPortOptions: (state) => state.airDestinPortOptions,
    airOrginPortOptions: (state) => state.airOrginPortOptions
  }
}

export default basiData
